﻿import bulmaCollapsible from '@creativebulma/bulma-collapsible';

// Import general mixin for shared functionality.
import defaultApp from './defaultApp.js';

// Import components for this specific app.
import ListItem from './components/ListItem.vue';
import SkeletonList from './components/SkeletonList.vue';

const listViewApp = {
    // Overwrite default app functionalities as you please by using the spread operator.
    components: {
        ListItem,
        SkeletonList
    },
    ...defaultApp,
    mounted() {
        this.init();
        this.$nextTick(() => {
            bulmaCollapsible.attach('.is-collapsible-vue');
        });
    }
};

export default listViewApp;
